import Questions from './Questions'

export default Questions
